<template>
<v-chart class="chart" :option="option" />
</template>

<script>
import {
  use
} from "echarts/core";
import {
  CanvasRenderer
} from "echarts/renderers";
import {
  BarChart,
  LineChart
} from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

import { getCouponData } from "@/api/api.js";

export default {
  components: {},
  data() {
    return {
      option: {
        tooltip: {},
        // legend: {
        //   data: ["事故总数", "处理完成", "未处理", "未名数据"],
        //   right: 0,
        //   textStyle: {
        //     color: "#a3fffe",
        //     fontSize: "16",
        //   },
        // },
        xAxis: [{
          type: "category",
          data: ["宁波", "衡州", "杭州", "台州", "温州"],
          axisPointer: {
            type: "shadow",
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#a3fffe",
            },
          },
          axisTick: {
            show: false
          }
        }, ],
        yAxis: [{
            type: "value",
            min: 0,
            max: 50,
            interval: 10,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#a3fffe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#114556",
                type: "dotted"
              }
            }
          },
          {
            type: "value",
            show: false,
            min: 0,
            max: 50,
            interval: 10,
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [{
            name: "事故总数",
            type: "bar",
            data: [0, 0, 0, 0, 0],
            itemStyle: {
              normal: {
                label: {
                  show: true
                }
              },
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: "#9b65e5",
                  },
                  {
                    offset: 1,
                    color: "#1f2949",
                  },
                ],
                globalCoord: false,
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    getData(params) {
      const _params = {
        "reqCodes": [31291000],
        "params": params
      }
      return getCouponData(_params).then((res) => {
        const data = res.data.data['31291000'];
        return Promise.resolve(data);
        }).catch(()=>{
          Promise.resolve({})
        })
      }
  },
  mounted() {
    Promise.all(
      [
        this.getData({"processType": 0}),
        this.getData({"processType": 1})
      ]
    ).then(res=>{
      let pendingProcess = 0,
          proccessed = 0
      res.forEach((items, index)=>{
        if(index === 0) {
          pendingProcess = items.reduce((a, item) => item["数量"] + a, 0)
        } else {
          proccessed = items.reduce((a, item) => item["数量"] + a, 0)
        }
      });
      this.option.xAxis[0].data = ["未处理", "已处理", "全部"]
      this.option.series[0].data = [pendingProcess, proccessed, pendingProcess + proccessed]
    })
    this.timer = setInterval(this.getData, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
};
</script>

<style scoped></style>
